export const priceViewScreen = {
    eventCategory: "DIY_N_Price",
    eventAction: "Price screen view"
};
